module.exports = __webpack_public_path__ + "img/Greenbriar Station Concepts_Page_2.711fc921.jpg";